import moment from "moment-timezone";
moment.tz.setDefault("Asia/Tokyo");

const isToday = (date) => {
  return moment(date).isSame(moment(), "day");
};

export { isToday };
export default moment;
